<div
  [ngClass]="{'pill-information' : state == 'information'}"
  class="border-1 border-radius-8 font-medium gap-4 px-12 py-4xs">
  <ng-content select="[children]"></ng-content>
</div>
